<style lang="less" scoped>
.home-topic-list{
}
</style>

<template>
  <div class="home-topic-list">
    <div v-for="topic in topicList" :key="topic.topicId">
      <a-topic :topic="topic"></a-topic>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import aTopic from './a-goods-topic'

export default {
  data() {
    return {
      topicList: [],
    }
  },
  methods: {
    ...mapActions([
      'getTopicGatherList',
    ]),
  },
  mounted() {
    this.getTopicGatherList({
      businessType: 1, // 1、表示bussniessId关联场景
      businessId: 1, // 首页场景传恒1
    }).then(res => {
      this.topicList = res
    })
  },
  components: {
    aTopic,
  }
}
</script>
